import React from "react";
import "./NewsletterSection.css";

// Import required components
import { Heading, Newsletter } from "../../../components";



const NewsletterSection = () => {
  return (
    <section className="newsletter-subscribe">
      <div className="content">

          <Heading title={"Subscribe To Our Newsletter"} linear /> {/* Section heading with linear style */}
          <p>Receive timely updates on fire safety tips, community events, and exclusive information from your local fire department.</p>

          <Newsletter variant='default' idPrefix='1' /> {/* Newsletter subscription form */}

      </div>
    </section>
  );
};

export default NewsletterSection;